import React from 'react';
import { Menu } from 'semantic-ui-react';
import { NavLink } from '../../../../lib/components/link';
import classes from './desktopNav.css';
import { MenuItemType } from '../../../../lib/proptypes/menu.proptypes';


const NavMenuItem = ({ item }) => (
// const NavMenuItem = ({ key, label, url, action, ...props }) => (
  <Menu.Item
    name={item.key}
    className={classes.menuButtonStyle}
    link
    key={item.key}
  >
    {item.action || item.url ?
      <NavLink {...item} style={{ color: 'inherit' }} />
      : <span>{item.label}</span>}
  </Menu.Item>
);

NavMenuItem.propTypes = {
  item: MenuItemType.isRequired,
};

export default NavMenuItem;



// WEBPACK FOOTER //
// ./src/app/components/Nav/DesktopNav/NavMenuItem.js